document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(".banner-video");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, {
    threshold: 0.5 // 50% visible
  });

  videos.forEach(video => {
    observer.observe(video);
  });

});